export default "__VITE_ASSET__DSM9jo1B__"